import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select, Tabs, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { FaSave } from 'react-icons/fa';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import useTaxesAPI from '../apis/taxesAPI';
import EventEmitter from '../utils/eventEmitter';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { RxUpdate } from 'react-icons/rx';
import { LiaPercentSolid } from "react-icons/lia";




const types = [
  { value: 'sales', label: 'Sales'},
  { value: 'purchase', label: 'Purchase'},
  { value: 'none', label: 'None'},
];

const taxComputation = [
  {value: 'fixed', label: 'Fixed'},
  {value: 'percent_of_price', label: 'Percentage of the Price'},
  {value: 'percent_of_price_included', label: 'Percentage of Price Included'}
]

const TaxChanges = () => {
  const taxes = useLoaderData();
  const [form] = Form.useForm();
  const { saveTax, updateTax } = useTaxesAPI();
  const { success, error } = useOutletContext();
  const params = useParams();
  const navigate = useNavigate();
  
  const handleSave = () => {
    let data = form.getFieldsValue();
    data['seo'] = data.name.toLowerCase().replace(/ /g, '-');
    data.seo = data.seo.replaceAll('%', '');
    // console.log(data)
    saveTax(data, success, error);
  }

  const handleUpdate = () => {
    let data = form.getFieldsValue();
    data.id = taxes._id;
    data['seo'] = data.name.toLowerCase().replace(/ /g, '-');
    data.seo = data.seo.replaceAll('%', '');
    // console.log(data)
    updateTax(taxes.seo, data, success);
  }

  useEffect(() => {
    EventEmitter.subscribe('tax_response', data => {
      navigate('/accounting/taxes/'+data);
    });
    return () => EventEmitter.unsubscribe('tax_response');
  },[])

  
  return (
    <div className='container mx-auto' style={{ maxWidth: '900px' }}>
      <div className=''>
        <div className='flex'>
        <h3 className='font-bold'>
          <Link to='/accounting/taxes' className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Taxes</Link> / {params.action}
        </h3>
        <Tooltip  title='save manually' placement='rightBottom' className='ms-1'>
          <Button onClick={handleSave} type='text' htmlType='button'
            disabled={ taxes.seo ? true : false}
            className='border-0 bg-transparent focus:bg-transparent'
            icon={<FaCloudArrowUp />}
          />
        </Tooltip>
        </div>
        {taxes.seo && <Button htmlType='button' icon={<RxUpdate />} onClick={handleUpdate}>{'UPDATE'}</Button>}
      </div>
      <div className='mt-5 bg-white'>
        <Form name="basic"
          className='shadow p-3' 
          form={form}
          initialValues={taxes.name ? taxes: {active: false, included_in_price: false}}
          autoComplete="off"
          variant='borderless'
        >
          <Row>
            <Col lg={{span: 11}}>
              <Form.Item label='Name' name="name" className='font-bold mb-2 column' required >
                <Input className='border-x-0 border-t-0 input-outline-none font-normal' placeholder='Enter description here' />
              </Form.Item>
              <Form.Item label='Tax Computation' name="tax_computation" className='font-bold mb-2 column' required >
                <Select options={taxComputation} />
              </Form.Item>
              <Form.Item label='Active' name="active" className='font-bold mb-2 column' valuePropName='checked' required >
                <Checkbox className='border-x-0 border-t-0 input-outline-none font-normal' />
              </Form.Item>
            </Col>
            <Col lg={{span: 11, offset: 1}}>
              <Form.Item label="Amount" name="amount" className='font-bold columns mb-2' required >
                <InputNumber min={1} className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' addonAfter={<LiaPercentSolid />}/>
              </Form.Item>
              <Form.Item label='Type' name={'type'} className='font-bold columns mb-2' required >
                <Select options={types} placeholder='select type' variant='borderless' className='border-x-0 border-t-0 font-normal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs
            className='mt-3'
            // onChange={onChange}
            type='card'
            items={[
              {
                key: '1',
                label: 'Options',
                children: 
                <>
                  <Form.Item label="Label on Invoices" name="label_on_invoices" className='font-bold columns mb-2' required >
                    <Input className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' />
                  </Form.Item>
                  <Form.Item label="Included in Price" name="included_in_price" valuePropName='checked' className='font-bold columns mb-2' required >
                    <Checkbox className='border-x-0 border-t-0 input-outline-none w-full border-0 font-normal' />
                  </Form.Item>
                </>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}

export default TaxChanges;